<template>
  <div>
    <select :value="language" @change="handleLanguageChange">
      <option v-for="(languageOption, index) in languages" :key="index" :value="languageOption.value">
        {{ languageOption.label }}
      </option>
    </select>
    <br />
    <button class="translate-button" @click="rootComponent">Translate Save</button>
  </div>
</template>

<script>
  import axios from "axios";
  import { nextTick } from "vue";

  export default {
    name: "LanguageSelector",
    props: {
      language: String,
      allLanguageData: Array,
    },
    data() {
      return {
        labelContent: {},
        filtersData: null,
        languages: [
          { value: "english", label: "English" },
          { value: "hindi", label: "Hindi" },
          { value: "gujrati", label: "Gujarati" },
          { value: "french", label: "French" },
          { value: "russian", label: "Russian" },
          { value: "punjabi", label: "Punjabi" },
          // Add more languages as needed
        ],
      };
    },
    methods: {
      async rootComponent() {
        nextTick(async () => {
          try {
            if (this.$route.matched[0] && !this.$route.matched[0].instances.default) {
              console.error("Component instance not found");
              return;
            }
            const componentInstance = this.$route.matched[0].instances.default;

            const rootElement = componentInstance.$el;
            if (!rootElement) {
              console.error("Component root element not found");
              return;
            }

            const labels = rootElement.querySelectorAll(".languageChange");
            labels.forEach((label) => {
              const className = label.id;
              const textContent = label.textContent.trim();
              if (textContent !== "" && className !== "") {
                this.labelContent[className] = textContent;
              }
              if (label.tagName == "INPUT") {
                const placeholder = label.placeholder;
                if (placeholder !== "" && className !== "") {
                  this.labelContent[className] = placeholder;
                }
              }
            });

            const res = await axios.post(`${process.env.VUE_APP_BASE_URL}lang/labels`, {
              route: this.$route.path,
              labels: this.labelContent,
              language: this.language,
            });
            console.log("Label content saved:", res.data);
            alert(`Language ${this.language} is saved`);
            this.labelContent = {};
          } catch (error) {
            console.error("Error saving label content:", error);
          }
        });
      },
      handleLanguageChange(e) {
        this.$emit("update:language", e.target.value);
        this.newFunc(e.target.value);
      },
      async newFunc(lang) {
        const routePath = this.$route.path;
        if (this.allLanguageData) {
          this.filtersData = this.allLanguageData.filter((item) => item.route == routePath && item.language == lang);
        }
        await nextTick();

        if (this.$route.matched[0] && !this.$route.matched[0].instances.default) {
          console.error("Component instance not found");
          return;
        }
        const componentInstance = this.$route.matched[0].instances.default;

        const rootElement = componentInstance.$el;
        if (!rootElement) {
          console.error("Component root element not found");
          return;
        }

        if (this.filtersData && this.filtersData.length > 0) {
          const data = this.filtersData[0];

          if (data.labels) {
            const labels = rootElement.querySelectorAll(".languageChange");
            labels.forEach((label) => {
              const className = label.id;
              if (data.labels[className]) {
                label.textContent = data.labels[className];
              }
              if (label.tagName === "INPUT") {
                if (data.labels[className]) {
                  label.placeholder = data.labels[className];
                }
              }
            });
          } else {
            console.warn("No labels found in filtersData");
          }
        } else {
          console.warn("No filtersData found or filtersData is empty");
        }
      },
    },
    watch: {
      "$route"() {
        this.newFunc(this.language);
      },
    },
    mounted() {
      this.newFunc(this.language);
    },
  };
</script>

<style>
  .select {
    widows: 100%;
  }
  .select select {
    width: 278%;
    margin-left: 12px;
    margin-bottom: 10px;
    padding: 6px;
    border: 0.5px sold lightgray !important;
    border-radius: 5px;
    outline: none;
    margin-top: 12px;
  }

  .translate-button {
    padding: 5px 10px;
    border: none;
    border-radius: 3px;
    background-color: #007bff;
    color: #fff;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .translate-button:hover {
    background-color: #0056b3;
  }
</style>
